import {
  HHButtonMenu,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import TablePagination, {
  TablePaginationProps,
} from '@mui/material/TablePagination';
import { formatCurrency } from '../../utils/currency-helpers';

import { ArrowDropDown } from '@mui/icons-material';
import { GridLevelName } from './grid-types';

export interface FooterAction {
  action: () => void;
  actionLabel: string;
  disabled: boolean;
}

export type GridFooterProps<T> = TablePaginationProps & {
  selectedRows?: T[];
  actions?: FooterAction[];
  gridLevel?: GridLevelName;
  getAmount?: (row: T) => number | null;
  rowsPerPageOptions?: number[];
};

export const GridFooter = <T,>({
  selectedRows = [],
  actions,
  gridLevel = GridLevelName.BILL,
  getAmount,
  rowsPerPageOptions = [25, 50, 75, 100],
  ...props
}: GridFooterProps<T>): JSX.Element => {
  const selectedCount = selectedRows.length;

  return (
    <HHStack
      gap={3}
      paddingX={2}
      paddingY={1}
      direction="row"
      justifyContent="space-between"
      sx={{
        minHeight: '48px',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
      }}
    >
      <TablePagination
        {...props}
        rowsPerPageOptions={rowsPerPageOptions}
        sx={{ padding: 0 }}
      />
      {actions && (
        <HHStack direction="row" gap={1} alignItems="center">
          <HHTypography hhVariant="muted" flex={1}>
            {selectedCount > 0
              ? `${selectedCount} ${gridLevel} selected`
              : `No ${gridLevel} selected`}
          </HHTypography>
          {getAmount && (
            <HHTypography hhVariant="muted" flex={1}>
              {selectedCount > 0
                ? `SUM: ${formatCurrency(
                    selectedRows.reduce((acc, row) => {
                      const amount = getAmount(row);
                      if (amount) {
                        return acc + amount;
                      }
                      return acc;
                    }, 0),
                  )}`
                : null}
            </HHTypography>
          )}
          <HHButtonMenu
            hhVariant="contained"
            menuItems={actions.map(action => ({
              label: action.actionLabel,
              onClick: action.action,
              disabled: action.disabled,
            }))}
            buttonLabel={
              <HHStack direction="row" gap={1} alignItems="center">
                <HHTypography hhVariant="button">Actions</HHTypography>
                <ArrowDropDown />
              </HHStack>
            }
          />
        </HHStack>
      )}
    </HHStack>
  );
};
